import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Loader from "../../../components/partials/components/loader";
import { getApiCall } from "../../../service/httpCall";
import { toast } from "react-toastify";
import { USER_ROLES } from "../../../utilities/constant";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { API_BACKEND_LOGS } from "../../../service/url";
import { Button } from "react-bootstrap";

const levelColors = {
  error: "#ef4444",
  warn: "#f59e0b",
  info: "#3b82f6",
};

const LogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);
  const [filters, setFilters] = useState({
    type: "combined",
    date: getTodayDate(),
    level: "",
    search: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);

  const logTypes = [
    "combined",
    "users",
    "outbound_campaigns",
    "numbers",
    "agents",
    "cdr_service",
    "billing_service",
    "report_download_service",
  ];

  const levels = ["info", "error", "warn"];

  function getTodayDate() {
    return new Date().toISOString().split("T")[0];
  }

  function getYesterdayDate() {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d.toISOString().split("T")[0];
  }

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = await AsyncStorage.getItem("user");
      if (!rawUser) return;

      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON", e);
        return;
      }

      setLoggedInUserRole(user.role);
    }

    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole !== USER_ROLES.SUPERADMIN) return;

    fetchLogs();
  }, [loggedInUserRole, appliedFilters]);

  const fetchLogs = () => {
    setLoading(true);

    const query = `?type=${appliedFilters.type}&date=${appliedFilters.date}&level=${appliedFilters.level}&search=${appliedFilters.search}`;

    getApiCall(`${API_BACKEND_LOGS}${query}`)
      .then((res) => {
        const formatted = res?.map((line, index) => ({
          id: index + 1,
          log: line,
        }));
        setLogs(formatted);
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  };

  if (loggedInUserRole && loggedInUserRole !== USER_ROLES.SUPERADMIN) {
    return <div style={{ padding: 20 }}>Access Denied</div>;
  }

  if (loading) return <Loader />;

  return (
    <div className="dash-section-card">
      <div className="dash-section-header">
        <h3>Logs Viewer</h3>
      </div>

      <div className="dash-table-toolbar" style={{ gap: 10, flexWrap: "wrap" }}>
        <Dropdown
          value={filters.type}
          options={logTypes}
          onChange={(e) => setFilters({ ...filters, type: e.value })}
          placeholder="Select Type"
        />

        <Dropdown
          value={filters.date}
          options={[getTodayDate(), getYesterdayDate()]}
          onChange={(e) => setFilters({ ...filters, date: e.value })}
          placeholder="Select Date"
        />

        <Dropdown
          value={filters.level}
          options={levels}
          onChange={(e) => setFilters({ ...filters, level: e.value })}
          placeholder="Level"
          showClear
          itemTemplate={(option) => (
            <span style={{ color: levelColors[option], fontWeight: 500 }}>
              {option.toUpperCase()}
            </span>
          )}
          valueTemplate={(option) =>
            option ? (
              <span style={{ color: levelColors[option], fontWeight: 600 }}>
                {option.toUpperCase()}
              </span>
            ) : (
              "Level"
            )
          }
        />

        <InputText
          placeholder="Search logs..."
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
        <Button
          variant="primary"
          disabled={loading}
          onClick={() => setAppliedFilters({ ...filters })}
        >
          {loading ? "Loading..." : "Apply"}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            const defaultFilters = {
              type: "combined",
              date: getTodayDate(),
              level: "",
              search: "",
            };
            setFilters(defaultFilters);
            setAppliedFilters(defaultFilters);
          }}
        >
          Clear Filters
        </Button>
      </div>
      <div style={{ width: "100%", overflowX: "scroll" }}>
        <DataTable
          value={logs}
          paginator
          rows={100}
          rowsPerPageOptions={[100, 200, 500, 1000, 2000, 5000]}
          globalFilter={globalFilter}
          className="dash-datatable"
          emptyMessage="No logs found"
        >
          <Column
            header="Line No."
            body={(rowData, { rowIndex }) => rowIndex + 1}
            style={{ width: "60px" }}
          />

          <Column
            field="log"
            header="Log"
            body={(rowData) => {
              const line = rowData.log;
              const match = line.match(/(\d{2}:\d{2}:\d{2})/);

              if (!match) {
                return (
                  <span
                    style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}
                  >
                    {line}
                  </span>
                );
              }

              const time = match[0];
              const parts = line.split(time);

              return (
                <span
                  style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}
                >
                  {parts[0]}

                  <span
                    style={{
                      fontWeight: "bold",
                      fontStyle: "italic",
                      textDecoration: "underline",
                      fontSize: "16px",
                      color: "rgb(0, 132, 219)",
                    }}
                  >
                    --{time}--
                  </span>

                  {parts[1]}
                </span>
              );
            }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default LogsPage;
